export const TextWidth = `
	width: 920px;
	@media (max-width: 1600px) { width: 960px; }
	@media (max-width: 1280px) { width: 940px; }
	flex-grow: 0;
	flex-shrink: 0;
	margin-left: auto;
	margin-right: auto;
`;